import myDayStyles from "./myDay.module.css";
import venchy from "../../images/questionnaire_doctor.png";
import { filterFuturedAppointments, getPrintDate } from "../../utils/utils";
import Pagination from "../pagination/pagination";
import { useAppSelector } from "../../services/hooks";
import {
  useGetCurrentQuestionnaireByUsersIdQuery,
  useGetMessageByUserIdQuery,
  useGetExercisesByUserIdQuery,
  useGetAppointmentsByUserIdQuery,
} from "../../services/api/user.api";
import { userSelector } from "../../services/selectors/user.selectors";
import { useState } from "react";
import Slider from "../slider/slider";
import { myDayUpdates } from "../../utils/constants";

function MyDay() {
  const user = useAppSelector(userSelector);
  const userAppointments =
    user.appointments &&
    filterFuturedAppointments(
      user.appointments.filter((item) => item.appointments.statusId)
    ).sort(
      (a, b) =>
        new Date(a.appointments.appointmentDate).getTime() -
        new Date(b.appointments.appointmentDate).getTime()
    );

  const updates = user.updates?.length ? user.updates : myDayUpdates;
  const exercises = user.exercises;
  const [activeUpdatesIndex, setActiveUpdatesIndex] = useState(0);
  const [activeAppointmentsIndex, setActiveAppointmentsIndex] = useState(0);
  const [activeVideoIndex, setActiveVideoIndex] = useState(0);

  useGetMessageByUserIdQuery({
    companyId: user.companyId,
    guid: user.guid,
  });
  useGetCurrentQuestionnaireByUsersIdQuery(
    {
      guid: user.guid,
      userId: Number(user.id),
    },
    { refetchOnMountOrArgChange: true }
  );
  useGetExercisesByUserIdQuery({ companyId: user.companyId, guid: user.guid });
  useGetAppointmentsByUserIdQuery({
    companyId: user.companyId,
    guid: user.guid,
  });

  return (
    <div className={myDayStyles.myDay}>
      <h3 className={myDayStyles.myDay__title}>כמה דברים במיוחד בשבילך:</h3>
      <div className={myDayStyles.myDay__section}>
        <h4 className={myDayStyles.myDay__sectionTitle}>עדכונים</h4>
        <div className={myDayStyles.notifications}>
          <div className={myDayStyles.notifications__venchy}>
            <img
              src={venchy}
              className={myDayStyles.notifications__img}
              alt={"תמונה של וונצ’י"}
            />
            <div>
              <p className={myDayStyles.notifications__name}>וונצ’י</p>
              <p className={myDayStyles.notifications__date}>
                {getPrintDate(new Date())}
              </p>
            </div>
          </div>
          <Slider
            items={updates}
            className={myDayStyles.notifications__text}
            activeIndex={activeUpdatesIndex}
            setActiveIndex={setActiveUpdatesIndex}
          />
          <button
            className={myDayStyles.nextBtn}
            onClick={() =>
              setActiveUpdatesIndex((prevIndex) =>
                prevIndex === updates.length - 1 ? 0 : prevIndex + 1
              )
            }
          />
        </div>
      </div>
      <Pagination
        items={updates}
        onClick={(index) => setActiveUpdatesIndex(index)}
        activeIndex={activeUpdatesIndex}
      />
      <div className={myDayStyles.myDay__section}>
        <h4 className={myDayStyles.myDay__sectionTitle}>תזכורות</h4>
        <ul className={myDayStyles.myDay__swiper}>
          {userAppointments && (
            <Slider
              items={userAppointments}
              className={myDayStyles.notifications__text}
              activeIndex={activeAppointmentsIndex}
              setActiveIndex={setActiveAppointmentsIndex}
            />
          )}

          {(!userAppointments || userAppointments.length === 0) && (
            <li
              className={`${myDayStyles.myDay__no_appointments_sectionCard} ${myDayStyles.myDay__sectionCard}`}
            >
              <div>
                <p className={myDayStyles.myDay__sectionText}>
                  טרם נקבעו פגישות
                </p>
              </div>
            </li>
          )}
        </ul>
        <button
          className={myDayStyles.nextBtn}
          onClick={() =>
            setActiveAppointmentsIndex((prevIndex) =>
              !userAppointments || prevIndex === userAppointments.length - 1
                ? 0
                : prevIndex + 1
            )
          }
        />
      </div>
      <div
        className={`${myDayStyles.myDay__section} ${myDayStyles.myDay__section_practice}`}
      >
        <h4 className={myDayStyles.myDay__sectionTitle}>תרגולים</h4>
        <Slider
          items={exercises}
          className={myDayStyles.notifications__text}
          activeIndex={activeVideoIndex}
          setActiveIndex={setActiveVideoIndex}
        />
        <button
          className={myDayStyles.nextBtn}
          onClick={() =>
            setActiveVideoIndex((prevIndex) =>
              prevIndex === exercises.length - 1 ? 0 : prevIndex + 1
            )
          }
          disabled={exercises?.length <= 2}
        />
      </div>
      <Pagination
        items={exercises?.map((v) => v.title)}
        onClick={(index) => setActiveVideoIndex(index)}
        activeIndex={activeVideoIndex}
      />
    </div>
  );
}

export default MyDay;
